import { BusinessClock } from '../../core/time/business-clock.service';
import { clockView } from '../../core/time/business-time';
import { JstDate } from '../../core/time/business-time';
import { Component, OnInit, inject } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PageTitleService } from '../../core/services/page-title.service';
import { NotificationService } from '../../core/services/notification.service';
import { MemberApiService } from '../../core/services/member-api.service';
import { StudioService } from '../../core/services/studio.service';

function getStartDateOptions(now: Date, deadLine: number) {
  return Array.from({ length: 4 }, (_, i) => {
    const hidden = i === 0 || (now.getDate() > deadLine && i === 1) || (now.getDate() <= deadLine && i === 3);
    const startDate = new JstDate(now.getFullYear(), now.getMonth() + i, 1);
    return {
      id: `${startDate.getFullYear()}-${startDate.getMonth() + 1}`,
      name: `${startDate.getFullYear()}年${String(startDate.getMonth() + 1).padStart(2, '0')}月`,
      date: startDate,
      hidden,
    };
  });
}

@Component({
    selector: 'app-notification-plan',
    imports: [FormsModule, RouterLink],
    templateUrl: './notification-plan.component.html'
})
export class NotificationPlanComponent implements OnInit {
  private readonly businessClock = inject(BusinessClock);
  private readonly clockContext = clockView(true);

  private pageTitle = inject(PageTitleService);
  private notificationService = inject(NotificationService);
  private memberApi = inject(MemberApiService);
  private studioService = inject(StudioService);
  private router = inject(Router);
  private toastr = inject(ToastrService);

  private deadLine = 9;
  member: any = {};
  studioPlans: any[] = [];
  products: any[] = [];
  startDateOptions: any[] = [];
  select: any = { studioPlan: null, startDate: null };
  isButtonDisable = false;

  async ngOnInit(): Promise<void> {
    this.pageTitle.set('fa s-icon-edit', '申請');
    this.deadLine = await this.notificationService.getDeadLine();
    const now = new JstDate();
    this.startDateOptions = getStartDateOptions(now, this.deadLine).filter(o => !o.hidden);
    this.member = await this.memberApi.getOne('self');
    const studio = await this.studioService.list(this.member?.studio?.id);
    this.studioPlans = (studio?.studioPlans ?? []).filter((p: any) => p.noShowAvailable === 1 && p.status === 0 && p.id !== this.member?.studioPlan?.id);
    const products = await this.studioService.getProduct(this.member?.studio?.id);
    this.products = Array.isArray(products) ? products.filter((product: any) => product.status === 0) : [];
  }

  async save(): Promise<void> {
    if (!await this.businessClock.confirm(this.clockContext, () => this.refreshClockDates())) return;
    if (!this.select.studioPlan || !this.select.startDate) return;
    this.isButtonDisable = true;
    const now = new JstDate();
    const json: any = {
      studioId: this.member.studio.id,
      memberId: this.member.id,
      requestMonth: `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`,
      requestType: 3,
      startDate: this.select.startDate.date,
      beforeStudioPlanId: this.member.studioPlan.id,
      afterStudioPlanId: this.select.studioPlan.id,
    };
    const v = await this.notificationService.upsert(json);
    if (!v) {
      this.toastr.error('諸届を申請できませんでした。', '', { timeOut: 5000 });
    } else {
      this.toastr.success('諸届を申請しました。', '', { timeOut: 5000 });
    }
    this.router.navigate(['/notification']);
  }
  private refreshClockDates(): void {
    this.startDateOptions = getStartDateOptions(new JstDate(), this.deadLine).filter(o => !o.hidden);
    this.select.startDate = null;
  }

}
